import React, { PureComponent } from "react";

class CalendarPage extends PureComponent {
  render() {
    const style = {
      width: "100%",
      // height: "auto",
      minHeight: 550
      // maxWidth: "100%"
    };

    return (
      <div>
        <h1>Calendar</h1>

        <div>
          <iframe
            title="Mark Allan's Calendar"
            src="https://calendar.google.com/calendar/embed?src=quje212pkk5e33sd1kqhea8g9g%40group.calendar.google.com&ctz=America%2FChicago"
            style={style}
            // style="border: 0"
            // width="800"
            // height="600"
            // frameborder="0"
            // frameBorder="10"
            // scrolling="no"
            // scrolling="yes"
          />
        </div>

        <div>
          <p>
            <a href="https://calendar.google.com/calendar/u/0?cid=cXVqZTIxMnBrazVlMzNzZDFrcWhlYThnOWdAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ"
              target="_blank"
              rel="noopener noreferrer"
              >Subscribe To Calendar</a>
            </p>
        </div>
      </div>
    );
  }
}

export default CalendarPage;



// WEBPACK FOOTER //
// ./src/routes/calendar/CalendarPage.js